module.exports = __webpack_public_path__ + "img/neighbor-3-image.9226df38.jpg";